import React, { PureComponent } from "react";
import {branch} from "baobab-react/higher-order";
// import * as playerActions from "../actions/playerActions";
import { FontAwesomeIcon } from "./shared/FontAwesomeIconWrapper";

// import {
//   View,
//   Text
// } from "react-native";

// import Utils from "../utils/Utils";

class Clock extends PureComponent {

  componentDidMount() {
    //this.props.dispatch(
	//	playerActions.startClock
    //);
  }

  render() {
    // var textColor = Utils.getConnectedAndLoggedInColor();

    // // If already logged elpased time show it, otherwise show running time
    // var elapsed;
    // try {
    //   if (this.props.logbook.hasOwnProperty("elapsed")) {
    //     elapsed = this.props.logbook.elapsed;
    //   } else {
    //     elapsed = this.props.flightTimer.elapsed;
    //   }
    // } catch (e) {
    //   elapsed = this.props.flightTimer.elapsed;
    // }

  //   return this.props.displayText ? (
	// 	<View style={{marginRight: 10}}>
  //       <Text style={{fontFamily: "Courier", fontSize: 12, color: "white"}}>{this.props.flightTimer.clock}</Text>
	// 		<Text style={{ fontFamily: "Courier", fontSize: 12, color: "white"}}>{this.props.flightTimer.clockUTC}</Text>
	// 		<Text style={{ fontFamily: "Courier", fontSize: 12, color: "white"}}>{elapsed}</Text>
	// 	</View>  
	// ) : (<Icon style={{ fontSize: 30, color: "white" }} name="clock"/>);
	  return <FontAwesomeIcon style={{ fontSize: 20, color: this.props.timerActive ? "red":"white" }} icon="stopwatch"/>;
  }
}

export default branch({
  timerActive: ["timers","timerActive"]
  // logbook: ["currentChecklist", "logbook"],
  // flightTimer: ["flightTimer"],
  // connection: ["connection"]
}, Clock);